import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 24C73172-9253-4C99-B214-B1C523115D79
 * name timer-sand-paused
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-sand-paused.svg
 * tags
 * - Date / Time 
 */
export const TimerSandPausedIcon = createSvgIcon(<><path d="M22 6V18H16L12 14L8 18H2V6H8L12 10L16 6M7.5 16L11.5 12L7.5 8H4V16M12.5 12L16.5 16H20V8H16.5M18 12V14H17.2L15.2 12M8.8 12L6.8 14H6V12Z" /></>, 'TimerSandPausedIcon');
export default TimerSandPausedIcon